import {useConfigurationsContext} from '../contexts/configuration-context';
import {DevConfig} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {useTariffsConfigurationsContext} from '../contexts/tariffs-configuration-context';

export function useDevConfig(): DevConfig {
  const {devConfig} = useConfigurationsContext();

  return devConfig;
}

export function useTariffsDevConfig(): DevConfig {
  const {devConfig} = useTariffsConfigurationsContext();

  return devConfig;
}
